// packages/api-client/src/services/public/featuresCatalogService.ts
import { getApiClient } from '../../client';
import { handleApiError } from '../../utils/handleApiError';
import type { ServiceResponse, FeaturesCatalogResponse, FeaturesFilterState } from '@dopomogai/types';

const PREFIX = '/public/features-catalog';

export const featuresCatalogService = {
  /**
   * Fetch features catalog using filter params.
   */
  getByFilters: (filters: FeaturesFilterState): ServiceResponse<FeaturesCatalogResponse> => {
    const params = new URLSearchParams();
    if (filters.q) params.set('q', filters.q);
    if (filters.categories && filters.categories.length > 0) {
      // Backend expects a single category for prefix matching; use the first
      params.set('category', filters.categories[0]);
    }
    if (filters.tier_max) params.set('tier_max', filters.tier_max);
    if (filters.maturity) params.set('maturity', filters.maturity);
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.offset) params.set('offset', String(filters.offset));

    const url = params.toString() ? `${PREFIX}?${params.toString()}` : PREFIX;

    return getApiClient()
      .get<FeaturesCatalogResponse>(url)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'fetching features catalog by filters'));
  },

  /**
   * Fetch specific features by keys (public).
   * Uses /public/features-catalog/by-keys with repeated 'keys' params:
   *   /by-keys?keys=a&keys=b&keys=c
   */
  getByKeys: (keys: string[]): ServiceResponse<FeaturesCatalogResponse> => {
    const uniqueSorted = Array.from(new Set(keys || [])).sort();
    const params = new URLSearchParams();
    uniqueSorted.forEach((k) => params.append('keys', k));
    const url = `${PREFIX}/by-keys${params.toString() ? `?${params.toString()}` : ''}`;

    return getApiClient()
      .get<FeaturesCatalogResponse>(url)
      .then((res) => res.data)
      .catch((err) => handleApiError(err, 'fetching features catalog by keys'));
  },
};